/**
 * A constant for the zero hash.
 *
 * (**i.e.** `"0x0000000000000000000000000000000000000000000000000000000000000000"`)
 *
 * @category Constants
 */
export const ZeroHash = '0x0000000000000000000000000000000000000000000000000000000000000000';
//# sourceMappingURL=hashes.js.map